import { factionRegionNumber, isHomeSector } from "./faction-routes.js";
import { snapshotCargoReward, type CargoRewardTerms } from "./reward-rules.js";
import type { LootCargoKind } from "./risk.js";
import type { CombatRules } from "./combat-rules.js";

export const SECTOR_PROGRESSION_VERSION = "sector-progression-20261027-v1";
export const NPC_RANKS = {
  0: { hp: 1, damage: 1, rewards: 1, xp: 1 },
  1: { hp: 1, damage: 1, rewards: 1, xp: 1 },
  2: { hp: 1.6, damage: 1.2, rewards: 2.5, xp: 2 },
  3: { hp: 2.2, damage: 1.5, rewards: 5, xp: 3 },
  4: { hp: 3.2, damage: 1.9, rewards: 8, xp: 4 },
} as const;
export type NpcRank = keyof typeof NPC_RANKS;
export function rankProgression(rules: CombatRules, rank: NpcRank) {
  return rules.format === 1 ? { hp: 1, damage: 1, rewards: 1, xp: 1 } : rules.rankRules[rank];
}
export function sectorRank(id: string): NpcRank {
  if (id === "training" || id === "patrol" || isHomeSector(id)) return 0;
  if (id === "wrecks") return 2;
  if (id === "frontier") return 4;
  const number = factionRegionNumber(id);
  switch (number) { case 2: return 1; case 3: return 2; case 4: return 3; case 5: return 4; default: return 0; }
}
/** Only new physical sources receive new prices. Held cargo and shared drops keep their terms. */
export function sectorCargoReward(kind: LootCargoKind, rank: NpcRank, factor: number = NPC_RANKS[rank].rewards): CargoRewardTerms {
  const base = snapshotCargoReward(kind);
  return { contentVersion: base.contentVersion,
    credits: (BigInt(base.credits) * BigInt(Math.round(factor * 10)) / 10n).toString(),
    components: Math.round(base.components * factor) };
}
